import { ClassRef } from "./types";


export class Error extends globalThis.Error
{
    constructor(
        message?: string,
        readonly innerError?: globalThis.Error
    )
    {
        super(message);
    }
}


export namespace Error
{
    export function getDump(error: globalThis.Error): string;
    export function getDump(error: globalThis.Error, stack: boolean): string;
    export function getDump(error: globalThis.Error, options: DumpOptions): string;
    export function getDump(error: globalThis.Error, arg?: boolean | DumpOptions): string
    {
        const stack =
            (typeof arg == "boolean")
                ? arg
                : !!arg?.stack;

        let dump = getDisplayString(error);

        if (stack && error?.stack)
            dump += `\n${getStack(error)}`;

        if (error instanceof Error && error.innerError)
        {
            const innerDump = getDump(error.innerError, stack);
            dump += `\n  Caused by: ${innerDump}`;
        }

        return dump;
    }

    export interface DumpOptions
    {
        stack?: boolean;
    }


    function getDisplayString(error: globalThis.Error): string
    {
        return (
            (error)
                ? (error.message)
                    ? `${error.constructor.name}: ${error.message}`
                    : error.constructor.name
                : "Error: Unknown error"
        );
    }

    function getStack(error: globalThis.Error): string
    {
        let { stack } = error;
        if (!stack)
            return "";
        stack = stack.split("\n").slice(1).join("\n");
        return stack;
    }
}


ClassRef.define(Error, "Error");
